module.exports = __webpack_public_path__ + "static/img/title-cn.7fc8db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/title/title-cn.png
// module id = iYrY
// module chunks = 1